import {
  index as baseIndex
 } from './Base';

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all technical data to build search form
 */
export function getSearchableTechnicalData(search = {}, is_service = false, is_order = false, client_user = true) {
  let finalSearch = Object.assign({}, search, {
    searchable: 1,
    active: 1
  });

  if(is_service) {
    finalSearch.available_service = 1;
  }

  if(is_order) {
    finalSearch.available_order = 1;
  }

  if(client_user) {
    finalSearch.client_readable = 1;
  }

  return baseIndex('technical_datas', 1, 0, finalSearch);
}
